import { render } from "./SetSDAdjustmentDialog.vue?vue&type=template&id=3fec9ce8"
import script from "./SetSDAdjustmentDialog.vue?vue&type=script&lang=js"
export * from "./SetSDAdjustmentDialog.vue?vue&type=script&lang=js"
script.render = render

export default script